/**
 * Paragraph component
 *
 * Optional props:
 * size : string - custom size (with unit)
 * small : boolean - applies small size
 * big : boolean - applies big size
 * primary : boolean - primary text color
 * light : boolean - light text color
 * bold : boolean - bold font weight
 * thin : boolean - thin font weight
 *
 * Examples of component:
 * <Paragraph>Standard paragraph</Paragraph>
 * <Paragraph small primary>Smaller font size and primary color</Paragraph>
 * <Paragraph bold>Bold font weight paragraph</Paragraph>
 *
 */

import styled from 'styled-components';
import { colors } from '../../variables';

const getFontSize = props => {
	if (props.size) return props.size;
	if (props.small) return '14px';
	if (props.big) return '18px';
	return '16px';
};

const getFontColor = props => {
	if (props.primary) return colors.blue.bromma;
	if (props.warning) return colors.red.warning;
	if (props.light) return '#fff';
	return colors.grey.graphite;
};

const getFontWeight = props => {
	if (props.bold) return '700';
	if (props.thin) return '300';
	return '400';
};

export default styled.p`
	font-size: ${props => getFontSize(props)};
	color: ${props => getFontColor(props)};
	font-weight: ${props => getFontWeight(props)};
	line-height: 1.5;
`;



// WEBPACK FOOTER //
// ./src/components/Common/Paragraph/Paragraph.js